const mapHeroSectionData = (data) => {
  const { hero, highlights, show_goal_on_app, forms } = data;
  const heroSectionData = {};
  const { hero_section_second_cta_text: heroSecondCTAText, heroStyles } =
    forms || {};

  heroSectionData.title = hero?.hero_title;
  heroSectionData.subtitle = hero?.hero_subtitle;
  heroSectionData.primaryCTA = hero?.hero_cta_title;
  heroSectionData.secondaryCTA = hero?.hero_cta_title_secondary;
  heroSectionData.image = hero?.hero_logo;
  heroSectionData.features = highlights?.components;
  heroSectionData.description = hero?.hero_description;

  heroSectionData.goalList = show_goal_on_app?.components;

  heroSectionData.heroSecondCTAText = heroSecondCTAText;

  heroSectionData.heroStyles = heroStyles;

  return heroSectionData;
};

const mapHowItWorksData = (data) => {
  const { features_and_benefits: howItWorks } = data;

  const howItWorksData = {};

  howItWorksData.title = howItWorks?.title;
  howItWorksData.list = howItWorks?.components?.map((comp) => ({
    title: comp?.title,
    subTitle: comp?.sub_title,
    image: comp?.image,
  }));

  return howItWorksData;
};

const mapTestimonialsData = (data) => {
  const { testimonials } = data;
  const testimonialsData = {};

  testimonialsData.title = testimonials?.title || "";
  testimonialsData.testimonials =
    testimonials?.components?.map(
      ({ title: userName, sub_title: comment, image }) => ({
        userName,
        comment,
        image,
      })
    ) || [];

  return testimonialsData;
};

const mapHelpSectionData = (data) => {
  const { floating_banner: floatingBanner } = data;
  const helpSectionData = {};

  helpSectionData.title = floatingBanner?.title;
  helpSectionData.primaryButtonText = floatingBanner?.cta_title;
  helpSectionData.secondaryButtonText = floatingBanner?.cta_title_secondary;

  return helpSectionData;
};

const mapFeaturesSectionData = (data) => {
  const { services: features } = data;
  const featuresSectionData = {};

  featuresSectionData.title = features?.title;
  featuresSectionData.features =
    features?.components?.map(({ title, sub_title: subTitle, image }) => ({
      title,
      subTitle,
      image,
    })) || [];

  return featuresSectionData;
};

const mapLeadNutritionistData = (data) => {
  const { hear_from_our_lead_nutritionist: leadNutritionist } = data;
  const leadNutritionistData = {};

  leadNutritionistData.title = leadNutritionist?.title;
  leadNutritionistData.subTitle = leadNutritionist?.description;
  leadNutritionistData.videoUrl = leadNutritionist?.url;
  leadNutritionistData.thumbnail = leadNutritionist?.image;

  return leadNutritionistData;
};

const mapFormData = (data) => {
  const { hero, forms, package_info: packages } = data;
  const formData = { success: {} };

  formData.title = forms?.sub_title;
  formData.subtitle = forms?.description;

  formData.showNameField = forms?.showNameField;
  formData.showEmailField = forms?.showEmailField;
  formData.showPhoneField = forms?.showPhoneField;
  formData.showGoalField = forms?.showGoalField;
  formData.showPackageField = forms?.showPackageField;
  formData.showStartDateField = forms?.showStartDateField;
  formData.showPrimaryCTA = forms?.showPrimaryCTA;
  formData.showRequestCallback = forms?.request_callback;
  formData.showTermsAndConditions = forms?.showTermsAndConditions;

  formData.namePlaceHolder = forms?.namePlaceHolder;
  formData.emailPlaceholder = forms?.emailPlaceholder;
  formData.mobilePlaceholder = forms?.mobilePlaceholder;
  formData.goalPlaceholder = forms?.goalPlaceholder;

  formData.gtmIdHealthGoal = forms?.gtmIdHealthGoal;
  formData.gtmIdPackages = forms?.gtmIdPackages;
  formData.gtmIdSinglePackage = forms?.gtmIdSinglePackage;
  formData.gtmIdPrimaryCTA = forms?.gtmIdPrimaryCTA;

  formData.goalFieldLabel = forms?.goalFieldLabel;
  formData.packageFieldLabel = forms?.packageFieldLabel;
  formData.startDateLabel = forms?.startDateLabel;

  formData.isPrimaryCTAWithPrice = forms?.isPrimaryCTAWithPrice;
  formData.isPrimaryCTAWithCallback = forms?.isPrimaryCTAWithCallback;
  formData.primaryCTAText = forms?.primaryCTAText;
  formData.secondaryCTAText = forms?.secondaryCTAText;

  const services = Array.isArray(forms?.services)
    ? forms?.services?.find(({ value }) => value === "nutrition")
    : forms?.services;
  formData.goalOptions = services?.slugs || [];

  formData.packageOptions =
    packages?.map(
      ({
        title,
        strikeout_price: price,
        price: discountedPrice,
        currency_code: priceConstant,
        slug: packageSlug,
        duration,
        image = "https://d1mxd7n691o8sz.cloudfront.net/staging/static/uploads/check-verified-02_1.png",
        recommended,
        no_of_classes: numberOfClasses,
        course_type: courseType,
      }) => ({
        title,
        price,
        discountedPrice,
        priceConstant,
        packageSlug,
        duration,
        image,
        recommended,
        numberOfClasses,
        courseType,
      })
    ) || [];

  formData.success.image = forms?.image;
  formData.success.title = forms?.submission_title;
  formData.success.subTitle = forms?.submission_subtitle;
  formData.success.nextSteps = forms?.submission_extra_text;

  formData.pageType = forms?.pageSlug;
  formData.purchaseEventType = forms?.purchaseEventType;

  formData.defaultGoal = forms?.defaultGoal;
  formData.defaultPackage = forms?.defaultPackage;
  formData.defaultStartDateOffset = forms?.defaultStartDateOffset;

  formData.packageSlug = forms?.default_package_slug;

  return formData;
};

const mapNutritionPaymentData = (data) => ({
  heroSectionData: mapHeroSectionData(data),
  howItWorksData: mapHowItWorksData(data),
  testimonialsData: mapTestimonialsData(data),
  helpSectionData: mapHelpSectionData(data),
  featuresSectionData: mapFeaturesSectionData(data),
  leadNutritionistData: mapLeadNutritionistData(data),
  formData: mapFormData(data),
});

export default mapNutritionPaymentData;
